import { BetHistoryRowData } from '../model/BetHistoryRowData'
import { create } from 'zustand'

export interface IBetHistoryStore {
  isOpened: boolean
  isLoading: boolean
  betCount: number
  totalStake: number
  totalPayout: number
  totalWinLose: number
  betList: BetHistoryRowData[]
  startTime: string
  endTime: string
  voucherId: string
  voucherStake: number
}

export const useBetHistoryStore = create<IBetHistoryStore>(() => ({
  isOpened: false,
  isLoading: false,
  betCount: 0,
  totalStake: 0,
  totalPayout: 0,
  totalWinLose: 0,
  betList: [],
  startTime: '',
  endTime: '',
  voucherId: '',
  voucherStake: 0,
}))
